<script>import { stateTheme, Theme } from "@infinitro/config";
import SealFlush from "./seal-flush.svelte";
import SealRocket from "./seal-rocket.svelte";
</script>

{#if $stateTheme === Theme.Rocketbet}
	<SealRocket />
{:else}
	<SealFlush />
{/if}
